import { useEffect, useState } from "react";

export type SchoolPageSection = { key: string; name: string };

export type SchoolPageNav = {
  schoolId: string;
  schoolName: string;
  sections: SchoolPageSection[];
  sectionId: string | null;
  pick: (key: string) => void;
};

let current: SchoolPageNav | null = null;
const listeners = new Set<(value: SchoolPageNav | null) => void>();

export function publishSchoolPageNav(value: SchoolPageNav | null) {
  current = value;
  listeners.forEach((fn) => fn(current));
}

/** Live while a school page is mounted. Null on every other page. */
export default function useSchoolPageNav() {
  const [value, setValue] = useState(current);
  useEffect(() => {
    listeners.add(setValue);
    setValue(current);
    return () => {
      listeners.delete(setValue);
    };
  }, []);
  return value;
}
